export default __webpack_public_path__ + "static/media/anchor.8bc3f94d.svg";